<template>
	<div class="callback">
	</div>
</template>

<script>
export default {
	name: 'Callback',
	data: () => ({
		zone: config.ZONE,
	}),
	async created() {
		let url

		if ('global' === this.zone) {
			url = `https://auth.c2.test.synology.inc/v1`
		} else {
			url = `https://auth.${this.zone}.c2.test.synology.inc/v1`
		}

		const code = this.getParameterByName('code')
		const state = this.getParameterByName('state')

		const resp = await fetch(`${url}/auth-callback?code=${code}&state=${state}`, {
			method: 'GET',
			headers: {
				'X-C2-Host-Name': 'hostname',	// FIXME
				'X-C2-Device-Name': 'test-devicename',
				'X-C2-Date': `${Date.now()}`,
			},
			credentials: 'include',
		})

		if (200 === resp.status) {
			const { redirect_to } = await resp.json()
			window.location = redirect_to
		}
	},
	methods: {
		getParameterByName: function(name, defaultValue = null, url = window.location.href) {
			const regex   = new RegExp(`[?&]${name.replace(/[[\]]/g, '\\$&')}(=([^&#]*)|&|#|$)`)
			const results = regex.exec(url)

			if (!results || !results[2]) {
				return defaultValue
			}

			return decodeURIComponent(results[2].replace(/\+/g, ' '))
		},
	}
}
</script>
